import { useContext } from 'react'

import { Context } from '@src/Infrastructure/Context'

export const useTranslation = (): {
    t: (key: string) => string
} => {
    const context = useContext(Context)

    return {
        t: (key: string) => {
            return context.translations?.[context.locale]?.[key] || key
        },
    }
}
